import { Md5 as md5 } from 'ts-md5'

// ensure these match Cid.go !!

export const cidForDirItemId = (itemId: number) => {
	return 'c' + md5.hashStr(`DirPrompt ${itemId}`)
}

export const cidForDirValue = (value: string) => {
	return 'c' + md5.hashStr(`DirValue ${value}`)
}